var React = require('react');

function FlipunitIconBulletWhite (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"reference"},React.createElement("path",{"className":"cls-1","d":"M.7,5.93a.7.7,0,0,1-.49-1.2L4.73.21a.7.7,0,0,1,1,0l4.52,4.52a.7.7,0,0,1-.5,1.2Z"})))]);
}

FlipunitIconBulletWhite.defaultProps = {"viewBox":"0 0 10.46 5.93"};

module.exports = FlipunitIconBulletWhite;

FlipunitIconBulletWhite.default = FlipunitIconBulletWhite;
